<template>
	<router-link v-if="access" :to="curLink">
		<font-awesome-icon v-if="fontawesomeicon" :icon="fontawesomeicon" />
		<span v-if="flagicon !== null && flagicon !== undefined && flagicon !== false" class="flag-icon" :class="flagicon"></span>
		<img v-if="imageBefore !== null && imageBefore !== undefined && imageBefore !== false" class="link-image" :src="imageBefore" />
		<template v-if="curText.length === 1">{{ curText[0] | ftc }}</template>
		<template v-else v-for="(t, ix) in curText">
			<br v-if="t === '<br>'" :key="ix" /><template v-else>{{ t | ftc }}</template>
		</template>
	</router-link>
	<span v-else>
		<font-awesome-icon v-if="fontawesomeicon" :icon="fontawesomeicon" />
		<span v-if="flagicon !== null && flagicon !== undefined && flagicon !== false" class="flag-icon" :class="flagicon"></span>
		<img v-if="imageBefore !== null && imageBefore !== undefined && imageBefore !== false" class="link-image" :src="imageBefore" />
		<template v-if="curText.length === 1">{{ curText[0] | ftc }}</template>
		<template v-else v-for="(t, ix) in curText">
			<br v-if="t === '<br>'" :key="ix" /><template v-else>{{ t | ftc }}</template>
		</template>
	</span>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Helper from '@/helper/helper'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// название
	//=========================================================================
	name: 'linkComponent',
	//=========================================================================
	// неизменяемые свойства
	//=========================================================================
	props: ['url', 'text', 'fontawesomeicon', 'flagicon', 'imageBefore', 'status', 'statusText', 'valueType', 'srcData'],
	//=========================================================================
	// изменяемые свойства
	//=========================================================================
	data() {
		return {
			// доступ к данной ссылке
			access: false,
			// обработанный текст
			curText: [],
			// ссылка
			curLink: '#',
			// статусы услуги
			serviceStatus: null,
			serviceStatusText: null
		}
	},
	//=========================================================================
	// при создании компонента
	//=========================================================================
	beforeMount() {
		// получаем ссылку по умолчанию
		this.curLink = this.url

		// статусы
		this.serviceStatus = this.status
		this.serviceStatusText = this.statusText

		// текст ссылки с разбивкой
		this.getText()

		// доступ в зависимости от статусов
		this.whatStatus()
	},
	//=========================================================================
	// методы компонента
	//=========================================================================
	methods: {
		getText(txt) {
			// обнуляем
			this.curText = []
			// исходный текст
			let _text = txt
			if (_text === undefined || _text === null) _text = this.text
			// если задан тип
			if (this.valueType === 'money')
			{
				let _v = parseFloat(_text)
				if (isNaN(_v))
					this.curText.push('-')
				else
					this.curText.push(Helper.Money2String(_v, 2, '.', ' '))
				return
			}
			// обработка текста - разделяем на массив по спец.разделителю
			if (_text && String(_text).indexOf('<br>') >= 0)
			{
				let _arr = String(_text).split('<br>')
				for (let k = 0; k < _arr.length; k++)
				{
					if (k > 0 && k < _arr.length) this.curText.push('<br>')
					this.curText.push(_arr[k])
				}
			}
			else this.curText.push(_text)
		},
		whatStatus() {
			// получим доступ
			this.access = this.isAccess(this.url)

			if (this.serviceStatus || this.serviceStatusText)
			{
				// если задан статус текущего процесса
				if (this.serviceStatusText)
				{
					// если это VDS - то откроем ссылку
					if (this.url.indexOf('/vds/view') === 0) this.access = true
					// для всех остальных закрываем
					else this.access = false
				}
				else
				{
					// текущего процесса нет, смотрим на статус - если услуга удалена
					if (this.serviceStatus === 'deleted')
					{
						// если это dns
						if (this.url.indexOf('/dns/view/') === 0)
						{
							this.access = false
							return
						}

						// если это домены и персоны
						if (this.url.indexOf('/person/update/') === 0 ||
							this.url.indexOf('/domains/update/') === 0)
						{
							// просто меняем на просмотр
							this.curLink = this.curLink.replace('/update/', '/view/')
							return
						}

						// просто меняем crud на service
						this.curLink = this.curLink
							.replace('/vds/', '/service/')
							.replace('/iso/', '/service/')
							.replace('/additional-services/', '/service/')
					}
					else
					{
						// если услуга не активна, не блочена, и не неоплачена - закрываем доступ
						if (this.serviceStatus !== 'active' && this.serviceStatus !== 'block' && this.serviceStatus !== 'notpaid')
						{
							this.access = false
						}
						else
						{
							// для доменов разрешено править только со статусом "active"
							if (this.url.indexOf('/domains/update/') === 0)
							{
								this.access = this.serviceStatus === 'active'
							}
						}
					}
				}
			}

			// если это DNS - нужно смотреть еще на флаги
			if (this.srcData && this.url.indexOf('/dns/view/') === 0)
			{
				if (this.srcData.can_update === false)
				{
					this.access = false
				}
			}
		}
	},
	//=========================================================================
	// наблюдатель
	//=========================================================================
	watch: {
		'status': function(status) {
			// запоминаем новое значение
			this.serviceStatus = status
			// доступ в зависимости от статусов
			this.whatStatus()
		},
		'statusText': function(statusText) {
			// запоминаем новое значение
			this.serviceStatusText = statusText
			// доступ в зависимости от статусов
			this.whatStatus()
		},
		'url': function(newUrl) {
			this.curLink = newUrl
		},
		'text': function(newText) {
			this.getText(newText)
		}
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style scoped>
svg {
	margin-right: 5px;
}

a.not-active-bonus {
	opacity: 0.5;
}

img.link-image {
	height: 20px;
    position: relative;
    top: -1px;
}
</style>



// WEBPACK FOOTER //
// link.vue?b5c05bde